// @flow

/**
 * A form value as a finite number, or undefined when it holds no number.
 *
 * NaN passes a `typeof value === 'number'` check, so an unfilled or unreadable
 * field has to read as undefined for a query guard to tell it from a real 0.
 */
export const toFiniteNumber = (value: mixed): number | void => {
  if (value === null || value === undefined) {
    return undefined;
  }

  // Number('   ') is 0, so an untrimmed blank would read as a real zero and open
  // a query guard that is meant to stay shut until the field holds a number.
  const trimmed = typeof value === 'string' ? value.trim() : value;

  if (trimmed === '') {
    return undefined;
  }

  const parsed = Number(trimmed);

  return Number.isFinite(parsed) ? parsed : undefined;
};
